/**
 * 简单事件总线 - 基于浏览器 EventTarget
 */
class EventBus {
  private target: EventTarget;

  constructor() {
    this.target = new EventTarget();
  }

  on(type: string, listener: EventListenerOrEventListenerObject) {
    this.target.addEventListener(type, listener as EventListener);
    return () => this.off(type, listener);
  }

  off(type: string, listener: EventListenerOrEventListenerObject) {
    this.target.removeEventListener(type, listener as EventListener);
  }

  emit(type: string, detail?: any) {
    const event = new CustomEvent(type, { detail });
    this.target.dispatchEvent(event);
  }
}

export const eventBus = new EventBus();


